export const styles = {
  wrapper: {
    minHeight: '20rem',
    height: '100%',
  },

  widget: {
    height: '100%',
    px: 2.75,
    py: 2,
  },
};
